export default function WhatWeDo() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: 'Instant Response',
      description: 'Replies within seconds so customers stay engaged'
    },
    {
      icon: 'ri-repeat-line',
      title: 'Automatic Follow-Up',
      description: 'Checks back automatically so leads don\'t go cold'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Simple Tracking',
      description: 'See who\'s interested and ready to book'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 text-center mb-16">
          A System That Works While You're Working
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-teal-600 text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
